import { TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default ({ action, input, type, meta: { touched, error }, label, isNumber, item }) => {
    const inputRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const cleanInput = value => value.replace(/\s+/g, ' ').trim();

    const filterNumericValue = (value, code) => {
        if (code === 'balance') {
            value = value.replace(/[^0-9.+-]/g, '');
            value = value.replace(/(?!^)[+-]/g, '');
            value = value.replace(/^([+-]?)\.+/, '$1');
            const dot = value.indexOf('.');
            if (dot !== -1) {
                value = value.slice(0, dot + 1) + value.slice(dot + 1).replace(/\./g, '');
            }
        } else if (code === 'price') {
            value = value.replace(/[^0-9.]/g, '');
            value = value.replace(/^\.+/, '');
            const dot = value.indexOf('.');
            if (dot !== -1) {
                value = value.slice(0, dot + 1) + value.slice(dot + 1).replace(/\./g, '');
            }
        }
        return value;
    };

    return (
        <FormControl error={Boolean(touched && error)} variant="filled" fullWidth>
            {/* <InputLabel>{label}</InputLabel> */}
            <TextField
                {...input}
                autoComplete="off"
                label={label}
                variant="filled"
                type={type}
                InputProps={{ endAdornment: action }}
                inputRef={inputRef}
                onChange={e => {
                    let value = e.target.value;
                    if (isNumber) {
                        value = filterNumericValue(value, item?.code);
                    }
                    const cleanedValue = label === t('news.newsText') ? value : cleanInput(value);
                    input.onChange(cleanedValue);
                }}
                onBlur={e => {
                    let value = e.target.value;
                    if (isNumber && value.endsWith('.')) {
                        value = value.slice(0, -1);
                        input.onChange(value);
                    }
                    input.onBlur(value);
                }}
                onPaste={e => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData('text');
                    let value = pastedText;
                    if (isNumber) {
                        value = filterNumericValue(value, item?.code);
                    }
                    const cleanedText = cleanInput(value);
                    input.onChange(cleanedText);
                }}
                sx={{
                    '& input[type=number]::-webkit-outer-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                    },
                    '& input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                    },
                    '& input[type=number]': {
                        MozAppearance: 'textfield',
                    },
                }}
            />
            {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};
